import type { CartPayment } from '@eliadmin/core/src/api/cart/cart-types';

type PaymentMethod = Pick<CartPayment, 'id' | 'name' | 'gateway'>;

// The current store API exposes no credit-method code. Match the explicit manual
// credit label, never a database ID or a gateway such as Barion/HomeCredit.
const creditNames = new Set([
  'platba kreditom',
  'platba kreditmi',
  'platba kreditem',
  'platba kredity',
  'credit payment',
  'payment by credits',
  'pay with credits',
]);

export function isJobPortalCreditPayment(payment: PaymentMethod): boolean {
  if (payment.gateway?.trim()) return false;
  return creditNames.has((payment.name ?? '').trim().replace(/\s+/g, ' ').toLowerCase());
}

/** Return only configured, valid methods appropriate for the amount due. */
export function getJobPortalPaymentMethods<T extends PaymentMethod>(
  payments: readonly T[] | undefined,
  total: number,
): T[] {
  if (!Number.isFinite(total) || total < 0) return [];
  return (payments ?? []).filter(payment => {
    const id = Number(payment.id);
    return (
      Number.isSafeInteger(id) && id > 0 && isJobPortalCreditPayment(payment) === (total === 0)
    );
  });
}

export function keepJobPortalPaymentSelection<T extends PaymentMethod>(
  payments: readonly T[],
  selected: string,
): string {
  return payments.some(payment => String(payment.id) === selected)
    ? selected
    : (payments[0]?.id.toString() ?? '');
}
